// Runtime data module for the project-management module.
//
// Exports the arrays the components/utils consume as MUTABLE live bindings. They start empty and
// are populated from the Rails API (GET /projects/dataset) via `applyLiveDataset`. There is no
// bundled fake-data fallback: if the fetch fails the bindings stay empty and DATA_SOURCE flips to
// 'error' so pages can show an honest error state.
//
// Components subscribe to swaps via the useProjectsData() hook, which re-renders them after
// applyLiveDataset / markDataError runs.

import { CrewAssignment, JobInvoice, ProjectJob, ProjectOrder, StatusChange, Technician } from './projectsTypes';

export type { CrewAssignment, JobInvoice, ProjectJob, ProjectOrder, StatusChange, Technician };

export let PROJECT_JOBS: ProjectJob[] = [];
export let PROJECT_ORDERS: ProjectOrder[] = [];
export let CREW_ASSIGNMENTS: CrewAssignment[] = [];
export let STATUS_HISTORY: StatusChange[] = [];
export let TECHNICIANS: Technician[] = [];
export let JOB_INVOICES: JobInvoice[] = [];
export let DEPARTMENTS: string[] = [];
export let DATA_SOURCE: 'idle' | 'live' | 'error' = 'idle';

export interface ProjectsDataset {
  jobs: ProjectJob[];
  orders: ProjectOrder[];
  assignments: CrewAssignment[];
  departments: string[];
  technicians?: Technician[];
  invoices?: JobInvoice[];
  status_history?: StatusChange[];
}

const deriveTechnicians = (assignments: CrewAssignment[]): Technician[] => {
  const map = new Map<string, string>();
  assignments.forEach((a) => {
    if (a.emp_id) map.set(a.emp_id, a.tech_name);
  });
  return Array.from(map.entries())
    .map(([emp_id, name]) => ({ emp_id, name }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

export const applyLiveDataset = (dataset: ProjectsDataset): void => {
  PROJECT_JOBS = dataset.jobs ?? [];
  PROJECT_ORDERS = dataset.orders ?? [];
  CREW_ASSIGNMENTS = dataset.assignments ?? [];
  DEPARTMENTS = dataset.departments ?? [];
  TECHNICIANS = dataset.technicians?.length ? dataset.technicians : deriveTechnicians(CREW_ASSIGNMENTS);
  JOB_INVOICES = dataset.invoices ?? [];
  STATUS_HISTORY = dataset.status_history ?? [];
  DATA_SOURCE = 'live';
};

// Fetch failed — leave the bindings empty and flag the error so pages can surface it.
export const markDataError = (): void => {
  DATA_SOURCE = 'error';
};
